import { RECORDING_STATUS } from '@lyrahealth-inc/shared-app-logic/src/features/videoSession/constants'
import { FeedbackResponse } from '@lyrahealth-inc/shared-app-logic/src/models/feedback/Feedback'
import { VideoSession } from '@lyrahealth-inc/shared-app-logic/src/models/session/Session'

import { baseApi, RTKQueryTag } from '../../data/baseApi'

type GetVideoCallTokenArgs = {
  appointmentId: string | number
  providerId: string
  patientId: string
  sessionNumber?: number
  recording_status?: RECORDING_STATUS
}

type GetVideoSessionsArgs = {
  providerId?: string
  patientId?: string
  appointmentId?: string | number
}

type UpdateVideoSessionMetadataArgs = {
  id: string
} & Partial<VideoSession>

type GetVideoSessionRecordingArgs = {
  id: string
}

type GetVideoSessionRecordingResponse = {
  url: string
}

type SubmitVideoQualityFeedbackArgs = {
  entity_type: string
  entity_id?: string
  lyra_id?: string
  user_type: string
  feedback_response: FeedbackResponse[]
}

const videoSessionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    pingLT: builder.query<void, void>({
      query: () => ({
        method: 'get',
        url: '/lt/v1/ping',
      }),
    }),
    createVideoSession: builder.mutation<VideoSession, GetVideoCallTokenArgs>({
      query: ({ appointmentId, providerId, patientId, sessionNumber, recording_status }) => ({
        method: 'post',
        url: '/lt/v1/video/session',
        params: {
          appointment_id: appointmentId,
          patient_id: patientId,
          provider_id: providerId,
          session_number: sessionNumber,
          recording_status,
        },
      }),
      invalidatesTags: [RTKQueryTag.VIDEO_SESSION],
    }),
    getVideoSessions: builder.query<VideoSession[], GetVideoSessionsArgs>({
      query: ({ providerId, patientId, appointmentId }) => ({
        method: 'get',
        url: '/lt/v1/video/session',
        params: {
          provider_id: providerId,
          patient_id: patientId,
          appointment_id: appointmentId,
        },
      }),
      providesTags: [RTKQueryTag.VIDEO_SESSION],
    }),
    updateVideoSessionMetadata: builder.mutation<VideoSession, UpdateVideoSessionMetadataArgs>({
      query: ({ id, ...data }) => ({
        method: 'put',
        url: `/lt/v1/video/session/${id}`,
        data,
      }),
      invalidatesTags: [RTKQueryTag.VIDEO_SESSION],
    }),
    getVideoSessionRecording: builder.query<GetVideoSessionRecordingResponse, GetVideoSessionRecordingArgs>({
      query: ({ id }) => ({
        method: 'get',
        url: `/lt/v1/video/session/${id}/content/cloudfront`,
      }),
    }),
    submitVideoQualityFeedback: builder.mutation<void, SubmitVideoQualityFeedbackArgs>({
      query: (data) => ({
        method: 'post',
        url: '/fdbks/v1/feedback',
        data,
      }),
    }),
  }),
})

export const {
  useLazyPingLTQuery,
  useCreateVideoSessionMutation,
  useGetVideoSessionsQuery,
  useUpdateVideoSessionMetadataMutation,
  useLazyGetVideoSessionRecordingQuery,
  useSubmitVideoQualityFeedbackMutation,
} = videoSessionApi

export default videoSessionApi
